import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { show as showModal } from 'redux-modal';

import Skill from 'ui/common/rebranding/components/Skill';

import { MODAL_NAME } from 'ui/users/skills/add/modal';
import { UPDATE_SKILL_IS_HIGHLIGHTED } from 'store/features/users/action-types';

class AddUserSkillModalTrigger extends Component {
  static propTypes = {
    isHighlighted: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    autoBind(this);
  }

  onClick() {
    const { isHighlighted } = this.props;
    this.props.updateIsHighlighted(isHighlighted);
    this.props.showModal(MODAL_NAME);
  }

  render() {
    return (
      <div>
        <Skill skillLevel={0} onClick={this.onClick} isPointer onHover fixed>
          <small>
            <b>
              <FormattedMessage
                id="users.skill.add.modal-trigger.label"
                defaultMessage="Add New Skill"
              />
            </b>
          </small>
        </Skill>
      </div>
    );
  }
}

const mapDispatchToProps = function(dispatch) {
  return {
    showModal: modalName => dispatch(showModal(modalName)),
    updateIsHighlighted: isHighlighted =>
      dispatch({
        type: UPDATE_SKILL_IS_HIGHLIGHTED,
        payload: { isHighlighted },
      }),
  };
};

export default connect(null, mapDispatchToProps)(injectIntl(AddUserSkillModalTrigger));
